import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import CustomDarkCheckbox from '../components/CustomDarkCheckbox';
import {
  AGENCY_CATEGORIES,
  CATEGORY_LIST,
  CATEGORY_LABELS,
} from "../constants/agencyCategories";
import { createProduct, uploadToCloudinary } from "../services/productService";


const AddProductPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialTab = location.state?.activeTab || "Details";

  const [activeTab] = useState(initialTab);

  // Basic fields
  const [name, setName] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [Locat, setLocat] = useState("");
  const [Category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rentalFee, setRentalFee] = useState("");
  const [description, setDescription] = useState("");
  const [rating, setRating] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");

  // Extra fields
  const [subcategory, setSubcategory] = useState("");
  const [size, setSize] = useState("");
  const [brand, setBrand] = useState("");
  const [condition, setCondition] = useState("");
  const [color, setColor] = useState("");

  const [model, setModel] = useState("");
  const [transmission, setTransmission] = useState("");
  const [fuel, setFuel] = useState("");
  const [seats, setSeats] = useState("");
  const [driver, setDriver] = useState("");

  const [area, setArea] = useState("");
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [cameras, setCameras] = useState(false);
  const [pool, setPool] = useState(false);
  const [garden, setGarden] = useState(false);

  const [capacity, setCapacity] = useState("");
  const [type, setType] = useState("");
  const [buffet, setBuffet] = useState("");

  const [imageCover, setImageCover] = useState(null); // الكوفر
  const [images, setImages] = useState([null, null, null, null]); // باقي الصور
  const [imagePreviews, setImagePreviews] = useState([null, null, null, null]);


  useEffect(() => {
    const newPreviews = images.map((img) => (img ? URL.createObjectURL(img) : null));
    setImagePreviews(newPreviews);

    return () => {
      newPreviews.forEach((url) => url && URL.revokeObjectURL(url));
    };
  }, [images]);

  const handleImageChange = (index, file, isCover = false) => {
  if (!file) return;

  if (isCover) {
    setImageCover(file);
  } else {
    const newImages = [...images];
    newImages[index] = file;
    setImages(newImages);
  }
};


  const handleImageRemove = (index, isCover = false) => {
  if (isCover) {
    setImageCover(null);
  } else {
    const newImages = [...images];
    newImages[index] = null;
    setImages(newImages);
  }
};


  const addImageSlot = () => setImages([...images, null]);

  const handleSave = async () => {
  if (!images[0]) {
    toast.error("Please select a cover image (first image).");
    return;
  }

  try {
    // رفع الصور على Cloudinary
    const uploadImage = async (file) => uploadToCloudinary(file);

    const uploadedCover = imageCover ? await uploadImage(imageCover) : null;
    const uploadedGallery = await Promise.all(
      images.filter(Boolean).map((img) => uploadImage(img))
    );


    // بيانات المنتج
    const newProduct = {
  name,
  vendorName,
  location: Locat,
  rentalFee,
  description,
  rating: 0,
  createdAt,
  updatedAt,
  subcategory,
  size,
  brand,
  condition,
  color,
  Category,
  price,
  quantity,
  model,
  transmission,
  fuel,
  seats,
  driver,
  area,
  bedrooms,
  bathrooms,
  cameras,
  pool,
  garden,
  capacity,
  type,
  buffet,
  imageCover: uploadedCover,
  images: uploadedGallery,
};


    const categoryKey = Category || AGENCY_CATEGORIES.CLOTHES;

    const addPromise = createProduct(categoryKey, newProduct);

    await toast.promise(addPromise, {
      loading: "Adding product...",
      success: "Product added successfully!",
      error: (err) =>
        err?.response?.data?.message ?? "Failed to add product, please try again.",
    });

    navigate(`/products?selected=${Category}`);
  } catch (error) {
    console.error("Add error:", error.response?.data || error.message);
    toast.error(error.message, { duration: 3000 });
  }
};


  return (
    <div>
      <div className="md:p-10 p-4 pb-4 text-base gap-4 w-full">
        {/* Page Titles */}
        <h1 className="text-2xl font-bold mb-2 dark:text-gray-200">Products</h1>
        <p className="text-gray-600 pb-6 text-sm flex flex-wrap gap-1 items-center">
          <Link to="/dashboard" className="hover:underline dark:text-gray-400">Dashboard</Link> /{" "}
          <Link to="/products" className="hover:underline dark:text-gray-400">Categories</Link> /{" "}
          {activeTab && (
            <>
              <Link to={`/products?selected=${activeTab}`} className="hover:underline dark:text-gray-400">{activeTab}</Link> /{" "}
            </>
          )}
          <span className="agarly-gradient-text font-bold">
            Add Product
          </span>
        </p>

        <div className="flex md:flex-row flex-col rounded-2xl md:p-0 p-2 bg-gray-50 min-h-screen gap-6 dark:bg-black">
          {/* Product Information */}
          <div className="bg-white rounded-2xl shadow p-6 md:w-[60%] w-full h-auto dark:bg-[#1A1A1B]">
            <h2 className="text-2xl font-semibold mb-4 dark:text-gray-200">Product Information</h2>
            <p className="text-sm text-gray-400 mb-4 ">Fill in the product details below to add a new item to your catalog.</p>
              <div className="space-y-4"> 

                <div className="space-y-2"> 
                  <label className="font-bold text-md dark:text-gray-200">Product Name</label> 
                  <input type="text" placeholder="Input product name" className="dark:bg-[#1A1A1B] dark:border-[#3D3D3D] w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-gray-700" value={name} onChange={(e) => setName(e.target.value)} /> 
                </div> 
                

                  <div className="w-full flex flex-col space-y-2"> 
                    <label className="font-bold text-md dark:text-gray-200">Vendor</label> 
                    <input type="text" placeholder="Input the name of the tenant" className="dark:bg-[#1A1A1B] dark:border-[#3D3D3D] border-2 border-gray-300 rounded-lg px-3 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-gray-700" value={vendorName} onChange={(e) => setVendorName(e.target.value)} /> 
                  </div> 


                <div className="flex gap-4"> 
                  <div className="w-1/2 flex flex-col space-y-2 relative"> 
                    <label className="font-bold text-md dark:text-gray-200">Product Category</label>
                    <select className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm  bg-white pr-8 dark:bg-[#1A1A1B] dark:border-[#3D3D3D] dark:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-700" value={Category} onChange={(e) => setCategory(e.target.value)} > 
                      <option value="">Select product category</option>
                      {CATEGORY_LIST.map((cat) => (
                        <option key={cat} value={cat}>{CATEGORY_LABELS[cat]}</option>
                      ))}
                    
                    </select> 
                  </div> 
                  
                  <div className="space-y-2 w-1/2"> 
                    <label className="font-bold text-md dark:text-gray-200">Rental fee</label> 
                    <input type="text" placeholder="Input Rental Fee" className="dark:bg-[#1A1A1B] dark:border-[#3D3D3D] w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-gray-700" value={rentalFee} onChange={(e) => setRentalFee(e.target.value)} /> 
                  </div> 
                </div> 

                <div className="space-y-2"> 
                  <label className="font-bold text-md dark:text-gray-200">Location</label> 
                  <input type="text" placeholder="Input Location" className="dark:bg-[#1A1A1B] dark:border-[#3D3D3D] w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-gray-700" value={Locat} onChange={(e) => setLocat(e.target.value)} /> 
                </div> 

                <div className="space-y-2"> 
                  <label className="font-bold text-md dark:text-gray-200">Description</label> 
                  <textarea type="text" placeholder="Input Description" className="dark:bg-[#1A1A1B] dark:border-[#3D3D3D] w-full h-[100px] border-2 border-gray-300 rounded-lg px-3 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-gray-700" value={description} onChange={(e) => setDescription(e.target.value)} /> 
                </div> 
 
              </div> 

              {(Category === AGENCY_CATEGORIES.CLOTHES || activeTab === AGENCY_CATEGORIES.CLOTHES) && (
                <div className="space-y-4">
                  <div className="flex flex-col space-y-2"> 
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Subcategory</label>
                    <select
                      className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm  bg-white pr-8 dark:bg-[#1A1A1B] dark:border-[#3D3D3D] dark:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={subcategory}
                      onChange={(e) => setSubcategory(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="68a13d58b0ef38d4e9553876">Men's Suits</option>
                      <option value="68a13d6bb0ef38d4e9553879">Women's Wedding Dresses</option>
                      <option value="68a13d7ab0ef38d4e955387c">Woman Soiree Dresses</option>
                    </select>
                  </div>
                  <div className="flex gap-4"> 
                    <div className="w-1/2 flex flex-col space-y-2"> 
                      <label className="font-bold text-md dark:text-gray-200">Size</label>
                      <input
                        type="text"
                        placeholder="Size"
                        className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700"
                        value={size}
                        onChange={(e) => setSize(e.target.value)}
                      />
                    </div>

                    <div className="w-1/2 flex flex-col space-y-2"> 
                      <label className="font-bold text-md dark:text-gray-200">Color</label> 
                      <input type="text" placeholder="Color" className="dark:bg-[#1A1A1B] border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700" value={color} onChange={(e) => setColor(e.target.value)} /> 
                    </div> 
                  </div>

                  <div className="flex flex-col space-y-2"> 
                    <label className="font-bold text-md dark:text-gray-200">Brand</label> 
                    <input
                      type="text"
                      placeholder="Brand"
                      className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={brand}
                      onChange={(e) => setBrand(e.target.value)}
                    />
                  </div>

                  <div className="flex flex-col space-y-2"> 
                    <label className="font-bold text-md dark:text-gray-200">Condition</label> 
                    <select
                      className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm  bg-white pr-8 dark:bg-[#1A1A1B] dark:border-[#3D3D3D] dark:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={condition}
                      onChange={(e) => setCondition(e.target.value)}
                    >
                      <option value="">Select Condition</option>
                      <option>Used many times</option>
                      <option>Medium used</option>
                      <option>As new</option>
                    </select>
                  </div>
                </div>
              )}

              {(Category === AGENCY_CATEGORIES.CARS || activeTab === AGENCY_CATEGORIES.CARS) && (
                <div className="space-y-4">
                  <div className="w-full flex flex-col space-y-2">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Subcategory</label>
                    <select
                      className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm  bg-white pr-8 dark:bg-[#1A1A1B] dark:border-[#3D3D3D] dark:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={subcategory}
                      onChange={(e) => setSubcategory(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="68a13b73b0ef38d4e9553862">SUV</option>
                      <option value="68a13b8bb0ef38d4e9553865">Electric/Hybrid</option>
                      <option value="68a13b61b0ef38d4e955385f">Sports</option>
                      <option value="68a13b53b0ef38d4e955385c">Luxury</option>
                      <option value="">4x4</option>
                      <option value="">Cabriolet</option>
                      <option value="">Coupe</option>
                      <option value="">Pickup</option>
                      <option value="">Van / Bus</option>
                      <option value="">Other</option>
                    </select>
                  </div>

                  <div className="flex flex-col space-y-2"> 
                    <label className="font-bold text-md dark:text-gray-200">Brand</label> 
                    <input
                      type="text"
                      placeholder="Input Brand"
                      className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={brand}
                      onChange={(e) => setBrand(e.target.value)}
                    />
                  </div> 
                  
                  <div className="flex flex-col space-y-2"> 
                    <label className="font-bold text-md dark:text-gray-200">Model</label> 
                    <input
                      type="text"
                      placeholder="Input Model"
                      className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={model}
                      onChange={(e) => setModel(e.target.value)}
                    />
                  </div>

                  <div className="w-full flex flex-col space-y-2">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Transmission</label>
                    <select className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm  bg-white pr-8 dark:bg-[#1A1A1B] dark:border-[#3D3D3D] dark:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-700" value={transmission} onChange={(e) => setTransmission(e.target.value)}>
                      <option>Automatic</option>
                      <option>Manual</option>
                    </select>
                  </div>

                  <div className="w-full flex flex-col space-y-2">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Fuel</label>
                    <select className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm  bg-white pr-8 dark:bg-[#1A1A1B] dark:border-[#3D3D3D] dark:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-700" value={fuel} onChange={(e) => setFuel(e.target.value)}>
                      <option>Benzine</option>
                      <option>Diesel</option>
                      <option>Electric</option>
                      <option>Petrol</option>
                      <option>Natural Gas</option>
                    </select>
                  </div>

                  <div className="w-full flex flex-col space-y-2">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Seats</label>
                    <input type="number" placeholder="Seats" className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700" value={seats} onChange={(e) => setSeats(e.target.value)} />
                  </div>

                  <div className="w-full flex flex-col space-y-2">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Driver</label>
                    <select className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm dark:border-[#3D3D3D] bg-white pr-8 dark:bg-[#1A1A1B] dark:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-700" value={driver} onChange={(e) => setDriver(e.target.value)}>
                      <option>With driver</option>
                      <option>Without driver</option>
                    </select>
                  </div>
                </div>
              )}

              {(Category === AGENCY_CATEGORIES.REAL_ESTATE || activeTab === AGENCY_CATEGORIES.REAL_ESTATE) && (
                <div className="space-y-4">
                  <div className="w-full flex flex-col space-y-2">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Subcategory</label>
                    <select
                      className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm dark:border-[#3D3D3D] bg-white pr-8 dark:bg-[#1A1A1B] dark:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={subcategory}
                      onChange={(e) => setSubcategory(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="68a13e37b0ef38d4e9553887">Appartment</option>
                      <option value="68a13e2db0ef38d4e9553884">Villas</option>
                      <option>Duplex</option>
                      <option value="68a13e43b0ef38d4e955388a">Townhouse</option>
                      <option value="68a13e57b0ef38d4e955388d">Commercial</option>
                      <option value="68a13e63b0ef38d4e9553890">Coastal</option>
                    </select>
                  </div>
                  
                  <div className="w-full flex flex-col space-y-2 mt-2">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Area (m²)</label>
                    <input type="number" placeholder="Area (m²)" 
                    className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D]focus:outline-none focus:ring-1 focus:ring-gray-700" 
                    value={area} onChange={(e) => setArea(e.target.value)} />
                  </div>

                  <div className="w-full flex flex-col space-y-2 ">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Bedrooms Num</label>
                    <input type="number" placeholder="Bedrooms" 
                    className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700"
                    value={bedrooms} onChange={(e) => setBedrooms(e.target.value)} />
                  </div>

                  <div className="w-full flex flex-col space-y-2 ">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Bathrooms Num</label>
                    <input type="number" placeholder="Bathrooms" 
                    className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700" 
                    value={bathrooms} onChange={(e) => setBathrooms(e.target.value)} />
                  </div>

                  <div className="flex justify-between p-4 items-center">
                    <label className="items-center dark:text-gray-200"><CustomDarkCheckbox checked={cameras} onChange={(e) => setCameras(e.target.checked)} className="mr-1" /> Cameras</label>
                    <label className="dark:text-gray-200"><CustomDarkCheckbox checked={pool} onChange={(e) => setPool(e.target.checked)} className="mr-1" /> Pool</label>
                    <label className="dark:text-gray-200"><CustomDarkCheckbox checked={garden} onChange={(e) => setGarden(e.target.checked)} className="mr-1" /> Garden</label>
                  </div>
                </div>
              )}

              {(Category === AGENCY_CATEGORIES.WEDDING || activeTab === AGENCY_CATEGORIES.WEDDING) && (
                <div className="space-y-4">
                  <div className="w-full flex flex-col space-y-2 mt-2">
                    <label className="font-bold text-md mt-2 dark:text-gray-200">Subcategory</label>
                    <select
                      className="dark:border-[#3D3D3D] w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm  bg-white pr-8 dark:bg-[#1A1A1B] dark:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-700"
                      value={subcategory}
                      onChange={(e) => setSubcategory(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="68a13f53b0ef38d4e9553899">Luxury Hotels</option>
                      <option value="68a13f69b0ef38d4e955389c">Beach Resorts</option>
                      <option value="68a13f79b0ef38d4e955389f">Garden Venues</option>
                      <option value="68a13f9eb0ef38d4e95538a5">Water Venues</option>
                      <option value="68a13f91b0ef38d4e95538a2">Private Venues</option>
                    </select>
                  </div>

                  <div className="w-full flex flex-col space-y-2 ">
                    <label className="font-bold text-md dark:text-gray-200">Area (m²)</label>
                    <input type="number" placeholder="Area (m²)" 
                    className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700" 
                    value={area} onChange={(e) => setArea(e.target.value)} />
                  </div>
                  
                  <div className="w-full flex flex-col space-y-2">
                    <label className="font-bold text-md dark:text-gray-200">Capacity Up to</label>
                    <input type="number" placeholder="Capacity" 
                    className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm dark:bg-[#1A1A1B] dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700" 
                    value={capacity} onChange={(e) => setCapacity(e.target.value)} />
                  </div>

                  <div className="w-full flex flex-col space-y-2">
                    <label className="font-bold text-md dark:text-gray-200">Type</label>
                    <select className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm  bg-white pr-8 dark:bg-[#1A1A1B] dark:text-gray-400 dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700" value={type} onChange={(e) => setType(e.target.value)}>
                      <option>Indoor</option>
                      <option>Open air</option>
                    </select>
                  </div>

                  <div className="w-full flex flex-col space-y-2">
                    <label className="font-bold text-md dark:text-gray-200">Buffet</label>
                    <select className="w-full border-2 border-gray-300 text-gray-600 rounded-lg px-3 py-3 text-sm  bg-white pr-8 dark:bg-[#1A1A1B] dark:text-gray-400 dark:border-[#3D3D3D] focus:outline-none focus:ring-1 focus:ring-gray-700" value={buffet} onChange={(e) => setBuffet(e.target.value)}>
                      <option>Open buffet</option>
                      <option>Meals</option>
                      <option>Desserts</option>
                    </select>
                  </div>
                </div>
              )}
            </div>
          

          {/* Image Product */}
          <div className="md:w-[45%] w-full space-y-6 flex flex-col ">
            <div className="bg-white rounded-2xl shadow p-6 h-auto dark:bg-[#1A1A1B]">
              <h2 className="text-2xl font-semibold mb-4 dark:text-gray-200">Product Images</h2>
              <p className="text-sm text-gray-600 mb-4 dark:text-gray-400">
                <span className="text-blue-400">Note:</span> Format photos SVG, PNG, or JPG (Max size 4mb)
              </p>

              {/* ✅ Cover Image */}
              <div>
              <h3 className="text-lg font-semibold mb-2 dark:text-gray-200">Cover Image</h3>
              {imageCover ? (
              <div className="relative w-[150px] h-[150px] mb-4"> 
                <label className="border border-dashed border-blue-400 rounded-xl bg-blue-50 dark:bg-[#2D2D2D] dark:border-[#3D3D3D] p-3 flex flex-col items-center justify-center cursor-pointer w-full h-full">
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/svg+xml"
                    className="hidden"
                    onChange={(e) => handleImageChange(null, e.target.files[0], true)}
                  />
                  
                    <img
                      src={URL.createObjectURL(imageCover)}
                      alt="Cover"
                      className="w-full h-full object-cover rounded-lg"
                    />
                    </label>

                    
                      <button
                        onClick={() => handleImageRemove(null, true)}
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                      >
                        ×
                      </button>
                  
                  </div>
                  ) : (
                    <div className="w-full relative mb-3">
                    <label className="border border-dashed border-blue-400 rounded-xl bg-blue-50 dark:bg-[#2D2D2D] dark:border-[#3D3D3D] p-4 flex flex-col items-center justify-center cursor-pointer w-full h-full">
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/svg+xml"
                        className="hidden"
                        onChange={(e) => handleImageChange(null, e.target.files[0], true)}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                      >
                        <defs>
                          <linearGradient id="grad-cover" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#5DEBFF" />
                            <stop offset="100%" stopColor="#7CC9FF" />
                          </linearGradient>
                        </defs>
                        <path
                          fill="url(#grad-cover)"
                          d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14h18zM5 5h14v14H5V5zm2 10l2.5-3 3.5 4.5 2.5-3L19 17H7z"
                        />
                      </svg>
                      <p className="text-xs mt-1 dark:text-gray-400">
                        Upload Image Cover
                      </p>
                    </label>
                  </div>
                  )}
                </div>

              {/* ✅ Gallery Images */}
              <div className="flex flex-wrap gap-3">
                {images.map((img, index) => (
                  <div key={index} className="relative md:w-[100px] md:h-[100px] w-[47%]">
                    <label className="border border-dashed border-blue-400 rounded-xl bg-blue-50 dark:bg-[#2D2D2D] dark:border-[#3D3D3D] p-3 flex flex-col items-center justify-center cursor-pointer w-full h-full">
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/svg+xml"
                        className="hidden"
                        onChange={(e) => handleImageChange(index, e.target.files[0])}
                      />
                      {imagePreviews[index] ? (
                        <img
                          src={imagePreviews[index]}
                          alt={`Product ${index + 1}`}
                          className="w-full h-full object-cover rounded-lg"
                        />
                      ) : (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                            <defs>
                              <linearGradient id={`grad-${index}`} x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#5DEBFF" />
                                <stop offset="100%" stopColor="#7CC9FF" />
                              </linearGradient>
                            </defs>
                            <path
                              fill={`url(#grad-${index})`}
                              d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14h18zM5 5h14v14H5V5zm2 10l2.5-3 3.5 4.5 2.5-3L19 17H7z"
                            />
                          </svg>
                          <p className="text-xs mt-1 dark:text-gray-400">Photo {index + 1}</p>
                        </>
                      )}
                    </label>

                    {img && (
                      <button
                        onClick={() => handleImageRemove(index)}
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                      >
                        ×
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>

           

            <div className="flex justify-end">
              <button
                onClick={handleSave}
                className="agarly-btn-primary text-agarly-dark hover:opacity-90 transition py-2 px-4 rounded-xl dark:text-gray-800"
              >
                Save Product
              </button>
            </div>
            
          </div>
        </div>
      </div>
      
      <div style={{ height: "40px" }}></div>
    </div>
  );
};

export default AddProductPage; 